<template>

  <span style="cursor:pointer;" @click="openModal()" >{{ EventStudyN.name }}</span>

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId"  v-if="active">
          <div class="modal-dialog modal-lg" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="editModalLabel">학습현황</h5>
  </div>

  <div class="modal-body">
    <table class="table">
      <tbody>
        <tr>
          <th>이름</th>
          <td style="text-align:center;">
            {{Tsub.username}}
          </td>
          <th>ID</th>
          <td style="text-align:center;">
              {{Tsub.name}}
          </td>
        </tr>
        <tr>
          <th>회원번호</th>
          <td style="text-align:center;">
              {{Tsub.id}}
          </td>
          <th>학습일자</th>
          <td style="text-align:center;">
              {{Tsub.datStudy}}
          </td>
        </tr>
        <tr>
          <th>학습목표</th>
          <td style="text-align:center;">
              {{Tsub.datPlan}}시간
          </td>
          <th>학습시간</th>
          <td>
            <input class="hidtype" style="width:90%;" :value="changedData.timeStudy || Tsub.timeStudy"
              :class="{'hidtype-changed': changedData.timeStudy}"
              @input="doChange('timeStudy', $event.target.value)" placeholder="학습시간" />
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.timeStudy"
              @click="delete changedData.timeStudy"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
        <tr>
          <th>학습건수</th>
          <td>
            <input class="hidtype" style="width:90%;" :value="changedData.intStudy || Tsub.intStudy"
              :class="{'hidtype-changed': changedData.intStudy}"
              @input="doChange('intStudy', $event.target.value)" placeholder="학습건수" />
            <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.intStudy"
              @click="delete changedData.intStudy"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
          <th>달성여부</th>
          <td>
            <select class="hidtype" :value="nvl(changedData.bitComplete, Tsub.bitComplete)"
                :class="{'hidtype-changed': changedData.bitComplete}"
                @input="doChange('bitComplete', $event.target.value)">
                <option value="1">달성</option>
                <option value="0">미달성</option>
              </select>
              <button class="btn btn-sm btn-danger" style="display:inline;" v-if="changedData.bitComplete"
                @click="delete changedData.bitComplete"><i class="bi bi-arrow-counterclockwise"></i></button>
          </td>
        </tr>
      </tbody>
    </table>
<div class="flex_center">
    <button type="button" class="btn btn-danger" @click="doSend()">수정</button>
    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"> Close</button>
  </div>
  </div></div>
</div>
</div>
</template>

<script>
import axios from 'axios'
export default {
    "name": "EventStudyN",
    components: {

    },
    methods: {
      nvl(str, altStr){
        if(typeof str == "undefined" || str == null) str = altStr ;
         return str ;

      },
      openModal() {
        this.active = true;
        this.modifyMode(this.EventStudyN)
        //console.log(this.Tsub.bookclubs);
        this.$nextTick(function(){
          var modalDom = document.getElementById("Modal" + this.TbtnId);
          var modal = (bootstrap.Modal.getOrCreateInstance(modalDom));
          modalDom.addEventListener('hidden.bs#Modal', function (event) {
            this.active = false;
          })
          //console.log(modalDom);
          modal.show();

        });
      },
      doChange(name, value) {
        if (this.Tsub[name] === value) {
          delete this.changedData[name];
        } else {
          this.changedData[name] = value;
        }
      },
      modifyMode(record){
        this.creating = false;
        this.changedData = {};
        this.Tsub =  {
          "studyNo": record.studyNo,
          "name": record.name,
          "username": record.username,
          "id": record.id,
          "datStudy": record.datStudy,
          "datPlan": record.datPlan,
          "timeStudy": record.timeStudy,
          "intStudy": record.intStudy,
          "bitComplete": record.bitComplete,
        }
      },
      doSend() {
        // 업데이트일 경우 patch /businesses/번호
        // 신규일 경우 post /businesses 후 post /admins 후 post /admins/번호/grants
        var data = this.changedData;

        var send = {
          method: this.creating ? "post" : "patch",
          url: '/studies/eventStudy' + "/" + this.Tsub.studyNo,
          data: data
        };

        //console.log(this.selBiz);
        //return;

            if(!this.active){
                //if(!confirm("아무 기관도 선택하지 않았습니다. 이 관리아이디는 로그인 할 수 없게 됩니다. 의도한 동작이 맞을 경우에만 확인을 누르세요.")) return;
                $.notify({
                  // options
                  message: '사용유무를 지정하셔야 합니다. '
                }, {
                  // settings
                  type: 'danger',
                  z_index: 9999
                });
                return;
            }

          if(Object.keys(this.changedData).length){

          axios(send).then((response) => {
            if (response.data.error) {
              $.notify({
                // options
                message: '처리할 수 없습니다. ' + response.data.error
              }, {
                // settings
                type: 'danger',
                z_index: 9999
              });
            } else {
              $.notify({
                // options
                message: '처리되었습니다'
              }, {
                // settings
                type: 'success',
                z_index: 9999
              });
              //this.$refs.qg.search()
              this.$parent.search();
              (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();
            }


          })

          }


      }
    },
        mounted() {
      this.Tsub = this.EventStudyN;
      //console.log(this.Tsub.bookclubs);
    },
    watch: {
      sub(){
        alert('tsub has been updated')
              this.Tsub = this.EventStudyN;
      }
    },
    props: {
      EventStudyN: {
        type: Object,
        default: {}
      },
      btnId: String
    },
    data(){
        return {
            TbtnId: this.btnId || Math.random().toString().substr(2, 5),
            creating: false,
            active: false,
            Tsub: {
              "studyNo": "",
              "name": "",
              "username": "",
              "id": "",
              "datStudy": "",
              "datPlan": "",
              "timeStudy": "",
              "intStudy": "",
              "bitComplete": ""
            },
            changedData: {
              // "studyNo": "",
              // "name": "",
              // "username": "",
              // "id": "",
              // "datStudy": "",
              // "datPlan": "",
              "timeStudy": "",
              "intStudy": "",
              "bitComplete": ""
            },
            product: null
        }
    }
}
</script>

<style>

</style>
